import { Address } from './Address'
import { withAddress } from './withAddress'

const ConnectedAddress = withAddress(Address)
export { ConnectedAddress as Address }
